import { Component, OnInit } from '@angular/core';
import { ModalService } from '@shared/errors/modal/modal.service';

@Component({
  selector: 'shell-equifax-questions',
  templateUrl: './equifax-questions.component.html',
  styleUrls: ['./equifax-questions.component.scss'],
})
export class EquifaxQuestionsComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  closeModal(): void {
    this.modalService.close();
  }
}
